// extracted by mini-css-extract-plugin
module.exports = {"content":"_3mTqTyMm","disclaimer":"_2mEz1cDl","showDetails":"_2kmU5U_D","cardFeatures":"_1in913s4","feature":"_30xpR9yS","footer":"_2Lm_viBf","modal":"_3HNGzOVE"};